<template>
    <button ref="btnElement" type="button" class="btn increase" :class="{ disabled: disabled }" :disabled="disabled">
        <div class="outer"><i class="fas fa-plus-circle"></i></div>
    </button>
</template>

<script setup lang="ts">
    import { Ripple } from "@/shared/ui/Ripple";
    import { onMounted, ref } from "vue";

    defineProps<{
        disabled?: boolean;
    }>();

    const btnElement = ref<HTMLButtonElement>();

    onMounted(() => {
        Ripple.bindRippleOut($(btnElement.value!), ".outer");
    });
</script>
